
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return {
      lng: lng,
      categories: myApp.categories['restaurant'],
      map: null,
      exploreMarkers: [],
      exploreMarkersObj: [],
      items: [],
      optionsOpened: false,
      myPosition: myApp.realPosition
    };
  },

  mounted() {
    const self = this,
          app = this.$app,
          $ = this.$;
    self.map = new L.Map('map-food-delivery', {
      zoomControl: false,
      minZoom: 1
    }).setView(myApp.latlng, 12);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a class="external" target="_system" ' + 'href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(self.map); // imposta evento ricerca

    var autocomplete = new google.maps.places.AutocompleteService();
    $('#explore-input').on('keyup change', () => {
      const value = $('#explore-input').val();

      if (value.length > 1) {
        autocomplete.getPlacePredictions({
          input: value,
          types: ['geocode']
        }, result => {
          let str = '';
          result.forEach((a, i) => {
            str += '<li><a href="javascript:myApp.foodDeliveryGoToMap(\'' + a.place_id + '\');">' + a.description + '</a></li>';
          });
          $('#explore-result-list').html(str);
          $('.explore-links-list').removeClass('hidden');
        });
      } else {
        $('#explore-result-list').html('');
        $('.explore-links-list').addClass('hidden');
      }
    });
    myApp.foodDeliveryGoToMap = self.goToMap;
    self.map.on('moveend', () => {
      self.getPoints();
    });
  },

  on: {
    pageBeforeIn(e, page) {
      if (!this.optionsOpened) {
        this.$app.popup.open('.popup-food-delivery');
        this.optionsOpened = true;
      }
    }

  },
  methods: {
    go() {
      this.getPoints();
    },

    goToMenu(id) {
      const self = this;
      myApp.server.get('imc/item/' + id).then(res => {
        myApp.currentPoi = res;
        self.$router.navigate('/menu/' + id + '/?food_delivery=1');
      });
    },

    zoomIn() {
      this.map.zoomIn();
    },

    zoomOut() {
      this.map.zoomOut();
    },

    removePoints() {
      // rimuove tutti i marker
      this.exploreMarkers = [];

      for (let i = 0; i < this.exploreMarkersObj.length; i++) {
        this.map.removeLayer(this.exploreMarkersObj[i]);
      }

      this.exploreMarkersObj = [];
    },

    getPoints() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const map = self.map;
      const bounds = map.getBounds();
      const zoom = map.getZoom();
      const icons = myApp.icons;
      const cur = {
        EUR: '€',
        USD: '$',
        GBP: '£'
      };
      let b = 'ne_lat=' + bounds._northEast.lat + '&ne_lng=' + bounds._northEast.lng + '&sw_lat=' + bounds._southWest.lat + '&sw_lng=' + bounds._southWest.lng;

      if (myApp.realPosition) {
        b += '&lat=' + myApp.realPosition[0] + '&lng=' + myApp.realPosition[1];
      }

      let type = 'restaurant';
      let checked = this.$('.selection:checked');
      let searchFilters = {
        viewAll: checked.length === 0,
        subtypes: [],
        filters: []
      }; // pizza -> 14

      if (searchFilters.viewAll === false) {
        checked.each(function () {
          let k = $(this).data('key');
          searchFilters.subtypes.push(k);
          if (k === 'pizza') searchFilters.subtypes.push('14');
        });
      }

      self.removePoints();
      const subtypes = '&' + app.utils.serializeObject(searchFilters);
      const withtakeaway = '&takeaway=1';
      const withdelivery = '&delivery=1';
      const api = 'imc/inbounds/?' + b + '&restaurant' + subtypes + withtakeaway + withdelivery + '&lgbt=0&getmenusettings';
      myApp.server.get(api).then(resp => {
        resp.forEach(o => {
          o.currency = cur[o.currency] || o.currency;
          let discount = 0;
          let event = false;
          let iconType = 'offer';

          if (o.offers.length) {
            for (let i = 0; i < o.offers.length; i++) {
              if (o.offers[i].type == 'discount' && o.offers[i].discount * 1 > discount) discount = o.offers[i].discount * 1;else if (o.offers[i].type == 'event') event = true;
            }
          }

          o.defaultimage = o.images[0].url || 'static/demo/' + o.type + '.jpg';
          self.exploreMarkers.push(o.id1);
          const k = 'subscription-' + o.subscription + (o.offers.length > 0 && o.type !== 'disco' ? '-offer' : '');
          const k1 = o.type;
          let text = '';

          if (discount && event) {
            iconType = 'mixed';
            text = '<i class="f7-icons" style="font-size: 10px">star_fill</i><br>' + discount + '%';
          } else if (discount) {
            text = discount + '%';
          } else if (event) {
            text = o.type === 'festival' ? '<i class="f7-icons">staroflife_fill</i>' : 'HAPPY';
          }

          let divIcon = L.divIcon({
            html: '<div class="icon-' + iconType + ' icon-offer-' + k1 + '">' + text + '</div>',
            iconSize: [40, 24],
            iconAnchor: [20, 28]
          });
          let m = L.marker(o.latlng, {
            icon: o.offers.length > 0 && o.type !== 'disco' ? divIcon : icons[k][k1],
            zIndexOffset: o.subscription * 1 > 0 ? 1001 : 0
          }).addTo(map).on('click', function (ev) {
            $('.page-content').scrollTop($('#' + o.id).offset().top, 500);
          });
          self.exploreMarkersObj.push(m);
        });
        return self.$setState({
          items: resp
        });
      }).then(() => {
        app.swiper.destroy('.food-delivery-swiper');
        app.swiper.create({
          el: '.food-delivery-swiper',
          spaceBetween: 5,
          slidesPerView: "auto"
        });
      }).catch(err => console.log(err, 'getInBounds:error'));
      $('.explore-links-list').addClass('hidden');
    },

    goToDetail(id, type, subscription, id1) {
      let page = type === 'disco' && subscription > 0 ? '/disco/' : '/detail/';
      this.$router.navigate(page + id + '/', {
        transition: 'f7-flip' // f7-cover, f7-circle, 

      });
    },

    goToMap(idx) {
      const self = this,
            $ = this.$,
            app = this.$app;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        placeId: idx
      }, (a, b) => {
        if (b !== 'OK') return;
        $('.explore-links-list').addClass('hidden');
        let latlng = [a[0].geometry.location.lat(), a[0].geometry.location.lng()];
        self.map.flyTo(latlng, 12);
      });
    },

    goToMyPosition() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const map = self.map;
      const options = {
        maximumAge: 3000,
        timeout: 30000,
        enableHighAccuracy: true
      };
      navigator.geolocation.getCurrentPosition(res => {
        let latlng = [res.coords.latitude, res.coords.longitude];
        map.flyTo(latlng, 10);
      }, err => {
        app.toast.show({
          text: err.message,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      }, options);
    },

    goToDiscount(idPoi, idDiscount) {
      console.log(idPoi, idDiscount);
      this.$router.navigate('/detail/' + idPoi + '/?offer=' + idDiscount);
    }

  },
  id: 'a14b2c45c9',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="/">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="right">\n          <!-- input Search -->\n          <div id="exploreInputSearch">\n            <i class=\'icon f7-icons\'>search</i>\n          </div>\n          <input id="explore-input" type="text" placeholder="';
      r += c(ctx_1.lng.homeSearchInput, ctx_1);
      r += '">\n          <span class="input-clear-button explore-clear-button"></span>\n        </div>\n      </div>\n    </div>\n\n    <div class="page-content">\n      <!-- Search result list -->\n      <div class="list links-list explore-links-list inset hidden" style="margin-top:0; max-width: 90vw">\n        <ul id="explore-result-list"></ul>\n      </div>\n      <!-- map -->\n      <div id="map-food-delivery"></div>\n      <!-- bootons zoom -->\n      <div class="menu-explore">\n        <div class="menu">\n          <div class="menu-inner">\n            <a href="#" class="menu-item">\n              <div @click="zoomOut" class="menu-item-content">\n                <i class="icon f7-icons">zoom_out</i>\n              </div>\n            </a>\n            <a href="#" class="menu-item">\n              <div @click="zoomIn" class="menu-item-content">\n                <i class="icon f7-icons">zoom_in</i>\n              </div>\n            </a>\n          </div>\n        </div>\n      </div>\n      <div class="fab fab-left-top color-deeporange">\n        <a href="#" class="link popup-open" data-popup=".popup-food-delivery">\n          <i class="icon f7-icons">arrow_2_circlepath</i>\n          <i class="icon f7-icons">arrow_2_circlepath</i>\n        </a>\n      </div>\n      <div class="fab fab-right-top color-imc">\n        <a href="#" @click="goToMyPosition">\n          <i class="icon material-icons">gps_fixed</i>\n          <i class="icon material-icons">gps_fixed</i>\n        </a>\n      </div>\n\n      <div class="food-delivery-results">\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.items, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n        <div class="card" id="';
          r += c(ctx_2.id, ctx_2);
          r += '">\n          <div class="card-content padding-bottom">\n            <!-- <div class="food-delivery-card-image cover margin-bottom"\n                 style="background-image: url(';
          r += c(ctx_2.defaultimage, ctx_2);
          r += ')"></div> -->\n\n            <div class="swiper-container food-delivery-swiper">\n              <div class="swiper-wrapper">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.images, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="swiper-slide">\n                  <div class="food-delivery-card-image cover" style="background-image: url(';
              r += c(ctx_3.url, ctx_3);
              r += ')"></div>\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div>\n              <div class="swiper-pagination"></div>\n            </div>\n\n            <div class="block text-align-center">\n              <h2 class="food-delivery-caption">';
          r += c(ctx_2.caption, ctx_2);
          r += '</h2>\n              ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.subtypes, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              ';
              r += Template7Helpers.js_if.call(ctx_3, "this && this != '0'", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' \n              <span class="food-delivery-card-subtypes">\n                ';
                  r += Template7Helpers.js.call(ctx_4, "!isNaN(this) ? myApp.categories[ ../../type ][ this ] : lng.deliveryTypes[ this ]", {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n              </span>\n              ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' \n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n              <div>\n\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_1.myPosition, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <i class="f7-icons">placemark_fill</i> <span class="text-bold"> ';
              r += c(ctx_3.distance, ctx_3);
              r += 'km </span> &nbsp;&nbsp;&nbsp;\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.info.takeaway, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <img width="24" style="vertical-align: middle; border-radius: 5px; " src="static/menu/takeaway.png" alt=""/>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.info.delivery, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <img width="24" style="vertical-align: middle; border-radius: 5px" src="static/menu/delivery.png" alt=""/>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div>\n\n              <!-- <h4>';
          r += c(ctx_2.description, ctx_2);
          r += '</h4> -->\n\n              <!-- <div class="row">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.discounts, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="food-delivery-discount" @click="goToDiscount(\'';
              r += c(ctx_3.idpoi, ctx_3);
              r += '\',\'';
              r += c(ctx_3.id, ctx_3);
              r += '\')">\n                  ';
              r += c(ctx_3.discount, ctx_3);
              r += '%\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div> -->\n\n              <div class="row">\n\n                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.menu_settings.delivery_price", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="col food-delivery-order-price">\n                  Consegna <br/> ';
              r += c(ctx_3.currency, ctx_3);
              r += ' ';
              r += c(ctx_3.menu_settings.delivery_price, ctx_3);
              r += '\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.menu_settings.delivery_order_min", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="col food-delivery-order-price">\n                  Ordine min. <br/> ';
              r += c(ctx_3.currency, ctx_3);
              r += ' ';
              r += c(ctx_3.menu_settings.delivery_order_min, ctx_3);
              r += '\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n              </div>\n\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.menu_settings.order_min_free_delivery", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="food-delivery-free text-align-center ">\n                Consegna GRATIS se ordine oltre  ';
              r += c(ctx_3.currency, ctx_3);
              r += ' ';
              r += c(ctx_3.menu_settings.order_min_free_delivery, ctx_3);
              r += '\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              \n              ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.menu_settings.delivery_max_radius, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="food-delivery-max-radius text-align-center">\n                Consegna fino a ';
              r += c(ctx_3.menu_settings.delivery_max_radius, ctx_3);
              r += ' km di distanza\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              \n              ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.info.order_locked, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="text-align-center bold text-color-red">\n                <i class="f7-icons">exclamationmark_triangle_fill</i>\n                Al momento non accettiamo ulteriori ordini\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "!this.info.takeaway", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="food-delivery-no-takeaway">\n                No ritiro locale\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "!this.info.delivery", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="food-delivery-no-takeaway">\n                Solo ritiro locale\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            \n           \n            <div class="block row margin-top">\n              <div class="col-50">\n                ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.info.order_locked, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <a href="#" @click="goToMenu(\'';
              r += c(ctx_3.id, ctx_3);
              r += '\')" class="button button-large button-round button-fill bg-color-imc text-color-primary">\n                  ';
              r += c(root.lng.order, ctx_3);
              r += '\n                  <img width="22" src="static/check.png" alt=""/>\n                </a>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div>\n              <div class="col-50">\n                <a href="/detail/';
          r += c(ctx_2.id, ctx_2);
          r += '/" class="button button-large button-round button-fill">+ Info</a>\n              </div>\n            </div>\n           \n          </div>\n        </div>\n\n        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n        <div class="block text-align-center">\n          <img src="static/no_data.svg" width="250"/>\n          <h3>Non ci sono attività di delivery / take away nella zona selezionata</h3>\n          <p>Allarga la zona di riferimento o modifica i parametri di ricerca</p>\n        </div>\n\n        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div>\n    </div>\n\n    <div class="popup popup-food-delivery popup-tablet-fullscreen">\n      <div class="view">\n        <div class="page">\n          <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n              <div class="left">\n                <a href="#" class="popup-close">\n                  <i class="icon icon-back"></i>\n                  <span class="if-not-md">Back</span>\n                </a>\n              </div>\n              <!-- <div class="title">Food Delivery / Take away</div> -->\n              <div class="right">\n                <!-- Link to close popup -->\n                <a class="link popup-close button-search" @click="go">';
      r += c(ctx_1.lng.search, ctx_1);
      r += '  <i class="f7-icons margin-left-half">search</i></a>\n              </div>\n            </div>\n          </div>\n          <!-- <div class="toolbar toolbar-bottom bg-translucent-light-1">\n            <div class="toolbar-inner">\n              <a href="#" @click="go" class="button button-large button-fill button-round bg-color-imc text-color-white margin-top"\n                 style="margin:0 auto 15px auto; width: 80%">Vai!</a>\n            </div>\n          </div> -->\n          <div class="page-content bg-color-white">\n            <div class="block">\n              <h2 class="text-align-center">\n                ';
      r += c(ctx_1.lng.foodDeliveryTitle, ctx_1);
      r += '\n              </h2>\n\n              <div class="list media-list">\n                <ul>\n                  <!-- deliveryType -> FOTO -->\n                  ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.lng.deliveryTypes, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  <li>\n                    <div class="item-content">\n                      <div class="item-media"><img src="static/menu/';
          r += c(data_2 && data_2.key, ctx_2);
          r += '.jpeg" width="80" /></div>\n                      <div class="item-inner">\n                        <div class="item-title-row">\n                          <div class="item-title">';
          r += c(ctx_2, ctx_2);
          r += '</div>\n                          <div class="item-after">\n                            <label class="checkbox">\n                              <input class="selection" data-key="';
          r += c(data_2 && data_2.key, ctx_2);
          r += '" type="checkbox" />\n                              <i class="icon-checkbox"></i>\n                            </label>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </li>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                  <!-- Cucina Nazionale -> Bandierina -->\n                  ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.categories.slice(3, 8), {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  <li>\n                    <div class="item-content">\n                      <div class="item-media"><img src="static/flags/';
          r += c(data_2 && data_2.index, ctx_2);
          r += '.png" width="40" /></div>\n                      <div class="item-inner">\n                        <div class="item-title-row">\n                          <div class="item-title">';
          r += c(ctx_2, ctx_2);
          r += '</div>\n                          <div class="item-after">\n                            <label class="checkbox">\n                              <input class="selection" data-key="';
          r += Template7Helpers.js.call(ctx_2, "@index + 3", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '" type="checkbox" />\n                              <i class="icon-checkbox"></i>\n                            </label>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </li>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                  <!-- Altro tipo di cucina -->\n                  ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.categories.slice(1, 2), {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  <li>\n                    <div class="item-content">\n                      <div class="item-inner">\n                        <div class="item-title-row">\n                          <div class="item-title">';
          r += c(ctx_2, ctx_2);
          r += '</div>\n                          <div class="item-after">\n                            <label class="checkbox">\n                              <input class="selection" data-key="';
          r += Template7Helpers.js.call(ctx_2, "@index + 1", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '" type="checkbox" />\n                              <i class="icon-checkbox"></i>\n                            </label>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </li>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                  ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.categories.slice(8, 12), {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  <li>\n                    <div class="item-content">\n                      <div class="item-inner">\n                        <div class="item-title-row">\n                          <div class="item-title">';
          r += c(ctx_2, ctx_2);
          r += '</div>\n                          <div class="item-after">\n                            <label class="checkbox">\n                              <input class="selection" data-key="';
          r += Template7Helpers.js.call(ctx_2, "@index + 8", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '" type="checkbox" />\n                              <i class="icon-checkbox"></i>\n                            </label>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </li>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                  ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.categories.slice(16), {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  <li>\n                    <div class="item-content">\n                      <div class="item-inner">\n                        <div class="item-title-row">\n                          <div class="item-title">';
          r += c(ctx_2, ctx_2);
          r += '</div>\n                          <div class="item-after">\n                            <label class="checkbox">\n                              <input class="selection" data-key="';
          r += Template7Helpers.js.call(ctx_2, "@index + 16", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '" type="checkbox" />\n                              <i class="icon-checkbox"></i>\n                            </label>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </li>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                </ul>\n              </div>\n\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    